// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".single-goods{padding:20px 0}.single-goods__list{display:grid;margin-top:40px;grid-gap:32px;gap:32px}.single-goods__list .model-widget{width:593px}.single-goods.is-mobile{padding:10px}.single-goods.is-mobile .single-goods__list{display:flex;flex-direction:column;gap:16px 0;margin-top:40px;padding:0 5px}.single-goods.is-mobile .single-goods__list .model-widget{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"siteFontFamily": "system-ui,sans-serif,math,ui-rounded,ui-monospce"
};
module.exports = ___CSS_LOADER_EXPORT___;
